module.exports = __webpack_public_path__ + "img/ad2.8777745.png";